import { render } from "./MenuTop.vue?vue&type=template&id=4f708c4d&scoped=true"
import script from "./MenuTop.vue?vue&type=script&lang=js"
export * from "./MenuTop.vue?vue&type=script&lang=js"

import "./MenuTop.vue?vue&type=style&index=0&id=4f708c4d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f708c4d"]])

export default __exports__